import React from "react";
import { Container, Col, Row } from "react-bootstrap";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the styles

function PreviewLgPomen({ multiple }) {
  const modalStyle = {
    border: "7px double black",
    backgroundColor: "white",
    marginTop: "20px",
  };
  return (
    <Container style={modalStyle}>
      <Row>
        <p style={{ padding: "2%" }}>Gornji tekst</p>
      </Row>
      <Col
        style={{ marginTop: "30px" }}
        className="d-flex justify-content-center"
      >
        <img
          style={{
            height: "50px",
            width: "50px",
            border: "none",
          }}
          src={require("../assets/krst.png")}
          alt="x"
        />
      </Col>
      <Row style={{ paddingTop: "2%" }}>
        <Col className="d-flex justify-content-around"></Col>
        <Col className="d-flex justify-content-around">
          {multiple && (
            <Carousel
              showArrows={false}
              infiniteLoop={true}
              autoPlay={true}
              interval={1000}
            >
              <img
                style={{
                  width: "150px",
                  height: "150px",
                  border: "3px solid black",
                }}
                src={require("../assets/user2.png")}
                alt={`Image`}
              />
              <img
                style={{
                  width: "150px",
                  height: "150px",
                  border: "3px solid black",
                }}
                src={require("../assets/user2.png")}
                alt={`Image`}
              />
              <img
                style={{
                  width: "150px",
                  height: "150px",
                  border: "3px solid black",
                }}
                src={require("../assets/user2.png")}
                alt={`Image`}
              />
            </Carousel>
          )}
          {!multiple && (
            <img
              style={{
                width: "150px",
                height: "150px",
                border: "3px solid black",
              }}
              src={require("../assets/user2.png")}
              alt={`Image`}
            />
          )}
        </Col>
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row style={{ paddingTop: "2%" }}>
        <Col className="d-flex justify-content-around"></Col>
        <Col
          style={{ fontWeight: "bold", letterSpacing: "1.2px" }}
          className="d-flex justify-content-around"
        >
          Ime Prezime
        </Col>
        <Col className="d-flex justify-content-around"></Col>
      </Row>
      <Row>
        <p style={{ padding: "2%" }}>Glavni tekst</p>
      </Row>

      <Row style={{ padding: "2%" }}>
        <b>
          <p style={{ float: "right" }} id="sakrij">
            Od koga
          </p>
        </b>
      </Row>
    </Container>
  );
}

export default PreviewLgPomen;
